import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vaccination-camp-tracker',
  templateUrl: './vaccination-camp-tracker.component.html',
  styleUrls: ['./vaccination-camp-tracker.component.scss']
})
export class VaccinationCampTrackerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
